import { deleteData, getData, postData } from '../plugins/ApiCalls'

export function getPaymentConnections() {
  return getData('payment-connections')
}

export function connectStripe(data) {
  return postData('payment-connections/stripe/connect', data)
}

export function connectPayPal(data) {
  return postData('payment-connections/paypal/connect', data)
}

export function disconnectPaymentConnection(id) {
  return deleteData('payment-connections/' + id)
}
